import { useLang } from '@/i18n';
import EcoImg from 'eco-design/base/eco-img';
import { useEffect, useState } from 'react';
import css from './index.module.scss';

const E: React.FC = () => {
    const { t } = useLang('d3u');
    const [enter, setEnter] = useState({
        label: false,
        title: false,
        desc: false,
    });

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const sceneArr: any[] = [];
            sceneArr.push(
                AniContainer.create({
                    triggerElement: '.D3U-E',
                    triggerHook: 1,
                    offset: '40%',
                    duration: '20%',
                    syncFromTo: [['.D3U-E .cover', { opacity: 0 }, { opacity: 1 }, 0.1]],
                }),
            );
            const arr: string[] = ['label', 'title', 'desc'];
            arr.forEach((k: string) => {
                const dom: HTMLElement | null = document.querySelector(`.D3U-E .${k}-box`);
                if (dom) {
                    sceneArr.push(
                        AniContainer.create({
                            triggerElement: dom,
                            triggerHook: 1,
                            offset: dom.offsetHeight + 120,
                            duration: '100%',
                            onEnter: () => setEnter((prev: any) => ({ ...prev, [k]: true })),
                            // onLeave: () => setEnter((prev: any) => ({ ...prev, [k]: false })),
                        }),
                    );
                }
            });
            return () => sceneArr.forEach((scene: any) => scene.destroy());
        }
    }, []);

    return (
        <section className={`${css.section} D3U-E GtmModuleData-section`} id="D3U-E" data-section-id={'D3U-E'} data-section-id2={t('E_title')}>
            <div className="sticky">
                <div className="img">
                    <EcoImg
                        pc="https://websiteoss.ecoflow.com/upload/image/1763360177202/Frame%202094654497.jpg"
                        h5="https://websiteoss.ecoflow.com/upload/image/1763360420776/Frame%202094654490.jpg"
                    />
                </div>
                <div className="cover"></div>
                <div className="info">
                    <div className="label-box">
                        <p className={`label${enter.label ? ' enter' : ''}`}>{t('E_label')}</p>
                    </div>
                    <div className="title-box">
                        <p className={`title${enter.title ? ' enter' : ''}`}>{t('E_title')}</p>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default E;
